// src/components/shared/ui/hart-bit/HeartBeat.jsx
import { useState, useEffect, useRef } from "react";
import { motion } from "framer-motion";

const HeartBeat = ({ payload, onEnd }) => {
  const [count, setCount] = useState(null);
  const [active, setActive] = useState(false);
  const intervalRef = useRef(null);

  useEffect(() => {
    if (!payload) return;

    // Default to 3 seconds if countFrom is missing/invalid
    const startValue =
      Number.isFinite(Number(payload?.countFrom)) && Number(payload?.countFrom) > 0
        ? Number(payload.countFrom)
        : 3;

    setCount(startValue);
    setActive(true);

    if (intervalRef.current) clearInterval(intervalRef.current);

    intervalRef.current = setInterval(() => {
      setCount((prev) => {
        if (prev <= 1) {
          clearInterval(intervalRef.current);
          intervalRef.current = null;
          handleEnd(payload);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, [payload]);

  const handleEnd = (p) => {
    // Only hide if we explicitly asked to disappear
    if (p?.disapear === true) {
      setTimeout(() => setActive(false), 600);
    }

    // Optional: auto-start timer after heartbeat
    if (p?.autoStartTimer && p?.timerDuration) {
      const timerPayload = {
        title: p.title || null,
        duration: p.timerDuration,
        reverse: !!p.reverse,
        mode: "start",
        startedAt: Date.now(),
      };
      const bc = new BroadcastChannel("operator-events");
      bc.postMessage({ actionId: "SHOW_TIMER", payload: timerPayload });
      bc.close();
    }

    if (typeof onEnd === "function") onEnd();
  };

  if (!active) return null;

  return (
    <div
      style={{ fontFamily: "Etemad" }}
      className="fixed inset-0 flex justify-center items-center bg-black text-white z-[99999]"
    >
      <video
        className="absolute inset-0 w-full h-full object-cover"
        src="/hart-bit/hart-bit.mp4"
        autoPlay
        loop
        muted
        playsInline
      />
      <motion.div
        key={count}
        initial={{ opacity: 0, scale: 1.4 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.8 }}
        transition={{ duration: 0.3 }}
        className="relative z-10 font-bold text-white"
        style={{ fontSize: "clamp(90px, 18vw, 700px)", lineHeight: 1 }}
      >
        {count}
      </motion.div>
    </div>
  );
};

export default HeartBeat;
